import EditableImage from "../../../../components/EditableImage";
import useImage from "../../../../hooks/useImage";
import useMultimedia from "../../../../hooks/useMultimedia";
import useRwas from "../../../../hooks/useRwas";
import useCompany from "../../../../hooks/useCompany";
import RWADataRow from "../components/RWADataRow";
import toast from "react-hot-toast";

export default function ExperienceCard({ rwa, reloadRwa, deleteRwa }) {
  const { activeCompany: company } = useCompany();
  const { convertToBlob } = useImage();
  const { upload } = useMultimedia();
  const { updateRwa } = useRwas();
  const data = rwa?.data;

  const handleUploadImage = async (newImage, key) => {
    if (!company || !company.id) {
      toast.error("No company selected. Cannot upload image.");
      return;
    }
    let fileToUpload = newImage;
    if (!(newImage instanceof File) && !(newImage instanceof Blob)) {
      const { blob, contentType } = await convertToBlob(newImage);
      fileToUpload = new File([blob], "image.png", { type: contentType });
    }
    const fileUrl = await upload(fileToUpload);
    await updateRwa(company.id, rwa.id, {
      params: {
        [key]: { value: fileUrl, type: "image" }
      },
      name: rwa?.name,
      type: rwa?.type,
    });
    reloadRwa && reloadRwa();
  };

  return (
    <div className="p-4 space-y-6 mb-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-1 h-full">
          <EditableImage
            imageClassName="!h-full object-cover"
            className="!h-full min-h-[300px]"
            image={data?.image?.value}
            onImageChange={(newImage) => handleUploadImage(newImage, "image")}
          />
        </div>
        <div className="md:col-span-2 text-sm text-gray-700 space-y-4">
          <RWADataRow field={data?.description} param="description" title="Description" />
        </div>
      </div>
    </div>
  );
}